import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import Skeleton from "@mui/material/Skeleton";
import classnames from "classnames";
import { useStyles } from "./Skeleton.styles.js";
var Skeleton_SkeletonVariants = /*#__PURE__*/ function(SkeletonVariants) {
    SkeletonVariants["circle"] = "circle";
    SkeletonVariants["rect"] = "rect";
    SkeletonVariants["text"] = "text";
    return SkeletonVariants;
}(Skeleton_SkeletonVariants || {});
var Skeleton_MUISkeletonVariants = /*#__PURE__*/ function(MUISkeletonVariants) {
    MUISkeletonVariants["circle"] = "circular";
    MUISkeletonVariants["rect"] = "rectangular";
    MUISkeletonVariants["text"] = "text";
    return MUISkeletonVariants;
}(Skeleton_MUISkeletonVariants || {});
const Skeleton_Skeleton = (t0)=>{
    const $ = c(18);
    const { variant: t1, width, height, radius, animation: t2 } = t0;
    const variant = void 0 === t1 ? "text" : t1;
    const animation = void 0 === t2 ? "pulse" : t2;
    let t3;
    if ($[0] !== radius) {
        t3 = {
            radius
        };
        $[0] = radius;
        $[1] = t3;
    } else t3 = $[1];
    const { classes: styles } = useStyles(t3);
    let t4;
    if ($[2] !== styles) {
        t4 = (skeletonVariant)=>styles[`${Skeleton_SkeletonVariants[skeletonVariant]}`];
        $[2] = styles;
        $[3] = t4;
    } else t4 = $[3];
    const getVariantStyles = t4;
    const convertToMUIVariant = _temp;
    let t5;
    if ($[4] !== getVariantStyles || $[5] !== radius || $[6] !== styles.body || $[7] !== styles.radius || $[8] !== variant) {
        t5 = classnames([
            styles.body,
            radius ? styles.radius : getVariantStyles(variant)
        ]);
        $[4] = getVariantStyles;
        $[5] = radius;
        $[6] = styles.body;
        $[7] = styles.radius;
        $[8] = variant;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== variant) {
        t6 = convertToMUIVariant(variant);
        $[10] = variant;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== animation || $[13] !== height || $[14] !== t5 || $[15] !== t6 || $[16] !== width) {
        t7 = /*#__PURE__*/ jsx(Skeleton, {
            className: t5,
            variant: t6,
            width: width,
            height: height,
            "data-testid": "skeleton-test-id",
            animation: animation
        });
        $[12] = animation;
        $[13] = height;
        $[14] = t5;
        $[15] = t6;
        $[16] = width;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
};
function _temp(skeletonVariant_0) {
    return Skeleton_MUISkeletonVariants[skeletonVariant_0];
}
export { Skeleton_Skeleton as Skeleton };
